export default __webpack_public_path__ + "media/Delete.aba1e495.svg";